import React from "react";
import { Box } from "@mui/material";
import {
  ROW_HEIGHT,
  BRANCH_WIDTH,
  BEFORE_ELEMENT_BG_COLOR,
  BEFORE_ELEMENT_TRANSITION_DURATION,
  L_SHAPE_BORDER_WIDTH,
  L_SHAPE_CORNER_RADIUS,
  CONNECTOR_TRANSITION_DURATION,
  CONNECTOR_TRANSITION_BASE_DELAY
} from "./RfqConstants";
import { tokens } from '../../../Common/designTokens'; // added

const RfqBranchVisualization = ({ 
  venues, 
  animationState, 
  linePosition, 
  connectorWidth 
}) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: BRANCH_WIDTH,
        backgroundColor: "transparent",
        "&::before": venues.length > 0
          ? {
              content: '""',
              position: "absolute",
              left: linePosition.left,
              top: 0,
              height:
                animationState === "entered"
                  ? `calc(${ROW_HEIGHT} * ${venues.length + 1} - ${ROW_HEIGHT}/2)`
                  : "0px",
              width: connectorWidth,
              borderLeft: `${L_SHAPE_BORDER_WIDTH} solid ${tokens.colors.bodyBorderColor50}`,
              borderBottom: `${L_SHAPE_BORDER_WIDTH} solid ${tokens.colors.bodyBorderColor50}`,
              borderBottomLeftRadius: "8px",
               // Increase z-index so the vertical line is never hidden
               zIndex: 3,
               transition: `height ${BEFORE_ELEMENT_TRANSITION_DURATION}, opacity 0.2s ease-in`,
               opacity: animationState === "entered" ? 1 : 0,
             }
           : {},
       }}
     >
       <Box sx={{ height: ROW_HEIGHT }} />
       {venues.map((_, index) => {
         const isLast = index === venues.length - 1;
         return (
           <Box
             key={index}
             sx={{
               height: ROW_HEIGHT,
               position: "relative",
               "&::before": !isLast
                 ? {
                     content: '""',
                     position: "absolute",
                     left: linePosition.connector,
                     top: "50%",
                     width:
                       animationState === "entered"
                         ? connectorWidth
                         : "0px",
                     height: "1px",
                     backgroundColor: tokens.colors.bodyBorderColor50,
                     zIndex: 2,
                     transition: `width ${CONNECTOR_TRANSITION_DURATION}`,
                     transitionDelay: `${
                       CONNECTOR_TRANSITION_BASE_DELAY * index
                     }s`,
                   }
                 : {},
             }}
           />
         );
       })}
     </Box>
   );
 };

 export default RfqBranchVisualization;
